<template>
   <div id="no-auth">
      <router-view></router-view>
   </div>
</template>

<script>
import { mapGetters } from "vuex";

// Helpers
import Redirect from "@/utils/redirect";

export default {
   computed: {
      ...mapGetters(["userAuthenticated", "organizationName", "appLoaded"]),

      isAuthenticated() {
         return !!this.userAuthenticated;
      }
   },
   methods: {
      async checkAuthentication() {
         const red = new Redirect(this.$route);

         if (await red.isRegisterPage()) {
            await red.signOut();
         }

         if (this.isAuthenticated) {
            this.sendTo("dashboard");
         } else {
            this.checkPage();
         }
      },
      checkPage() {
         const PAGE_NAME = this.$route.name;
         let NotPermitedName = "NotAuthenticated";

         if (PAGE_NAME == NotPermitedName) {
            this.sendTo("login");
         }
      },
      runValidation() {
         if (this.appLoaded) {
            this.checkAuthentication();
         }
      },
      sendTo(pageName) {
         this.$router
            .push({
               name: pageName,
               params: { organization: this.organizationName }
            })
            .catch(() => {});
      }
   },
   watch: {
      appLoaded() {
         this.runValidation();
      }
   },
   created() {
      this.runValidation();
   }
};
</script>

<style lang="scss">
@import "../../style/variable.scss";

#no-auth {
   background: $primary;
   height: 100%;
   min-height: 100vh;
   box-sizing: border-box;
}
</style>
